import { Container, Logo } from "@/components";
import { CONSTANTS } from "@/constants";
import { IMenuItem } from "@/interfaces";
import { ESize } from "@/interfaces/enums";
import Link from "next/link";
import { Fragment } from "react";

export const PublicFooter = () => {
  const PUBLIC_FOOTER_MENU_ITEMS: IMenuItem[] = [
    ...CONSTANTS.MENU.PUBLIC,
    {
      id: 'register',
      label: 'Register',
      href: '/register',
    },
    {
      id: 'login',
      label: 'Login',
      href: '/login',
    }
  ];

  const SITE_DETAILS_NAV_ITEMS: IMenuItem[] = [CONSTANTS.URLS.PRIVACY, CONSTANTS.URLS.TERMS];

  return(
    <footer className="bg-white">
      <div aria-hidden="true" className="bg-green-gradient py-1" />
      <Container additionalClassNames="flex md:flex-row md:items-center py-12">
        <div className="mb-4 md:mb-0">
          <Logo size={ESize.LG} />
          <p className="mt-4">&copy;{new Date().getFullYear()}, {CONSTANTS.PROJECT_TITLE}. All rights reserved</p>
        </div>

        <nav aria-label="Footer navigation" className="md:ml-auto">
          <h4 className="h5 mb-4">Menu</h4>
          <ul className="flex md:flex-col list-style-none m-0">
            {PUBLIC_FOOTER_MENU_ITEMS.map(({ id, label, href }) => (
              <li key={id} className="mr-4 ml-0 md:mr-0">
                <Link className="color-black block mb-3" href={String(href)}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </Container>

      <div className="flex items-center bg-green-500 color-white">
        <Container additionalClassNames="flex md:flex-row md:items-center py-3">
          <div className="flex-1">
            <span>Crafted by <Link className="color-white weight-500" href='https://netfront.com.au/' target="_blank">Netfront</Link></span>
          </div>
          <nav aria-label="Site details navigation">
            <ul className="grid grid-flow-col gap-2 list-style-none m-0">
              {SITE_DETAILS_NAV_ITEMS.map(({ id, label, href }, index) => (
                <Fragment key={id}>
                  <li className="ml-0">
                    <Link href={String(href)} target="_blank" className="color-white weight-500 text-decoration-none">{label}</Link>
                  </li>
                  {index < SITE_DETAILS_NAV_ITEMS.length - 1 && (
                    <span aria-hidden="true" className="block mx-2">|</span>
                  )}
                </Fragment>
              ))}
            </ul>
          </nav>
        </Container>
      </div>
    </footer>
  )
};